module.exports = __webpack_public_path__ + "static/img/rabbit.5d744e9b.gif";